// THIS UTIL HANDLES THE AFFILIATE CODE GENERATION
import { encode } from 'base-64';

export function generateAffiliateCode(uid) {
    // Simple base-64 encoding for demonstration purposes
    return encode(uid).replace(/=/g, '');
}
